import { motion } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { mediaUrl } from "@/lib/api";
import { useSettings } from "@/hooks/useSettings";

export const DeveloperBadge = () => {
  const s = useSettings();
  if (!s.developer_name) return null;
  return (
    <a className="dev-badge" href={s.developer_url || "#"} target="_blank" rel="noreferrer" title={s.developer_credit} data-testid="developer-badge">
      {s.developer_logo ? <img src={mediaUrl(s.developer_logo)} alt={s.developer_name} /> : <span className="dev-mark">{s.developer_name[0]}</span>}
      <span><small>Crafted by</small><b>{s.developer_name}</b></span>
    </a>
  );
};

export const Shell = ({ children }) => {
  const settings = useSettings();
  return (
    <>
      <Header settings={settings} />
      {children}
      <Footer settings={settings} />
      <DeveloperBadge />
    </>
  );
};

export const Reveal = ({ children, delay = 0, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, link, linkLabel, testId }) => (
  <Reveal className="section-head">
    <div>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
    </div>
    {link}
    {linkLabel && !link && <span data-testid={testId}>{linkLabel}</span>}
  </Reveal>
);

export const PageIntro = ({ crumb, title, children, description }) => (
  <div className="container page-intro">
    <Reveal>
      <span className="eyebrow">{crumb}</span>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
      {children}
    </Reveal>
  </div>
);
